import type { AxiosResponse } from 'axios';

import type { ResponseWithPagination } from '@/utils/types';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type {
  CampaignFilters, CampaignNames, CampaignText,
  StaticCampaignBody,
} from '../campaigns/types';
import type {
  IImage,
  IStaticAdv,
  StaticAdvType,
} from './types';

export const getAll = (data: Partial<StaticCampaignBody>)
  : Promise<void | AxiosResponse<ResponseWithPagination<IStaticAdv>>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/select`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

// export const getAds = (data: Partial<AdsBody>)
//   : Promise<void | AxiosResponse<ResponseWithPagination<ICampaign>>> => axiosInstance({
//   url: `${ROUTES.ADS}/select`,
//   method: 'POST',
//   headers: {
//     authorization: true,
//   },
//   data,
// });

export const getById = (id: string)
  : Promise<void | AxiosResponse<IStaticAdv>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/${id}`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const update = (id: string, data: IStaticAdv)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/${id}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const toggleArchivedCampaign = (id: string, data: Pick<IStaticAdv, 'archived'>)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/${id}`,
  method: 'PATCH',
  headers: {
    authorization: true,
  },
  data,
});

export const getFilters = (): Promise<void | AxiosResponse<Pick<CampaignFilters, 'org'>>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/select/filters`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getNames = (data: CampaignText<StaticAdvType[]>)
    : Promise<void | AxiosResponse<CampaignNames>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/select/names`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const uploadRefPhoto = (data: File)
  : Promise<void | AxiosResponse<IImage>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/ref-photo`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getImage = (hash: string)
  : Promise<void | AxiosResponse<File>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV}/ref-photo/${hash}`,
  method: 'GET',
  responseType: 'arraybuffer',
  headers: {
    authorization: true,
  },
});
